import { PILOT_MEMBERSHIP } from "@/src/constants/memberships";

import {
  LoginResponse,
  OrganizationEntity,
  OrganizationUserRoleResponse,
  UserTaxonomyEntity,
} from "../hooks/api/generated";

export function isOrganizationAdmin(
  taxonomy: UserTaxonomyEntity | undefined,
  organizationIdOrSlug: string | number
): boolean {
  return (
    (taxonomy?.organization?.slug === organizationIdOrSlug ||
      taxonomy?.organization?.id === Number(organizationIdOrSlug)) &&
    !!taxonomy?.organization?.organizationAdmins.length
  );
}

export function isUserAnOrganizationAdmin(
  taxonomy: UserTaxonomyEntity | undefined
): boolean {
  return !!taxonomy?.organization?.organizationAdmins.length;
}

export function hasPermission(
  roles: OrganizationUserRoleResponse[] | undefined,
  role: string
): boolean {
  return !!roles?.find((item) => item.role === role && item.hasAccess);
}

export function isOrganizationMember(
  authData: LoginResponse | undefined,
  organizationIdOrSlug: number | string
): boolean {
  return (
    authData?.userTaxonomy?.organization?.id === Number(organizationIdOrSlug) ||
    authData?.userTaxonomy?.organization?.slug === organizationIdOrSlug
  );
}

export function isPilotOrganization(
  organization?: OrganizationEntity
): boolean {
  return organization?.membership?.name === PILOT_MEMBERSHIP;
}

export function getOrganizationImages(
  organization?: OrganizationEntity,
  allowPilot: boolean = false
): {
  logoImageUrl?: string;
  coverImageUrl?: string;
} {
  if (isPilotOrganization(organization) && !allowPilot) {
    return {
      logoImageUrl: undefined,
      coverImageUrl: undefined,
    };
  }

  const logoImageUrl = organization?.organizationImage?.find(
    (img) => img?.image?.type === "logo"
  )?.image?.public_id;

  const coverImageUrl = organization?.organizationImage?.find(
    (img) => img?.image?.type === "banner"
  )?.image?.public_id;

  return {
    logoImageUrl,
    coverImageUrl,
  };
}
